import React, { useState } from "react";
import { StyledDropdownWrapper, StyledInfoMessage } from "../styles/styledComponents";
import MountingTypeField from "../types/MountingTypeField";

type DropdownProps = {
    field: MountingTypeField;
};

const Dropdown = (props: DropdownProps) => {
    const { field } = props;
   
    const handleChange = (value : string) => {
        setValue(value);
    };
    var options = [];
    const objects = JSON.parse(field.placeholder!);
    for (var i in objects) {
        options.push(objects[i]);
    }

    const [value, setValue] = React.useState(field.name?.toLowerCase() == "roof-inclination" ? options[options.length-1].value : options[0].value);
   

    return (
        <div style={{ display: "flex", flexDirection: "column", padding: "15px 0" }}>
            <label htmlFor={field.id.toString()}>{field.label}
            </label>
            <div style={{ display: "inline-flex", alignItems: "center" }}>
                <StyledDropdownWrapper id={field.id.toString()} value={value} onChange={e => handleChange(e.target.value as string)}>
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </StyledDropdownWrapper>
            </div>
            <StyledInfoMessage id={field.name + "-info"}>
                {field.description}
            </StyledInfoMessage>
        </div>
  );
};

export default Dropdown;
